import { Calendar } from '@fullcalendar/core';
import esLocale from '@fullcalendar/core/locales/es';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import momentPlugin from '@fullcalendar/moment';

const initializeMaintenanceCalendar = function () {
  const calendarEl = document.getElementById('maintenance-calendar');

  if (calendarEl) {
    const calendar = new Calendar(calendarEl, {
      locale: esLocale,
      plugins: [interactionPlugin, dayGridPlugin, listPlugin, momentPlugin],
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,dayGridWeek,dayGridDay,listWeek',
      },
      eventTimeFormat: 'h:mm A',
      nowIndicator: true,
      navLinks: true,
      dayMaxEvents: true,
      height: 650,
      slotLabelFormat: 'h:mm A',
      slotEventOverlap: true,
      selectable: true,
      selectMirror: true,
      events: '/scheduled_maintenances.json',
      defaultTimedEventDuration: '01:00',
      expandRows: true,
      displayEventTime: true,
      nextDayThreshold: '08:00:00',
      displayEventEnd: false,
      views: {
        dayGridMonth: {
          titleFormat: { year: 'numeric', month: 'long', day: 'numeric' },
        },
        dayGridWeek: {
          titleFormat: { year: 'numeric', month: 'long', day: 'numeric' },
        },
        listWeek: {
          titleFormat: { year: 'numeric', month: 'long', day: 'numeric' },
        },
      },

      eventClick(event) {
        $.getScript(event.edit_url, function () {});
      },
    });

    calendar.render();
  }
};

document.addEventListener('turbolinks:load', function () {
  initializeMaintenanceCalendar();
});
